import { App } from 'vue';
import rteLinksDirective from './rteLinks.directive';
import RouterLinkConditional from './RouterLinkConditional.vue';

export default function config(app: App): void {
    app.directive('rteLinks', rteLinksDirective);
    app.component(RouterLinkConditional.name, RouterLinkConditional);
}
